/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useMemo } from 'react';

import { theme, Modal, Icon, DatePicker } from 'fpay-ui';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { useBreakpoints } from '@hooks/NewBreakpoint';
import { useAuth, useConfig } from '@hooks';
import { isAllowed } from '@helpers/auth';

import selectSoftDescriptorLastMovements from '@services/selectSofDescriptorLastMovements';
import selectTypeLastMovements from '@services/selectTypeLastMovements';
import { getLimitDays } from '@helpers';
import SelectType from '../SelectType';
import CleanFilter from '../SelectType/CleanFilter';
import FiltersMobile from './FiltersMobile';
import InputSearch from '../InputSearch';

const fontTypes = {
  filters: css`
    ${({ theme }) => theme.textTypes['Caption-w400']};
    line-height: normal;
    color: ${theme.colors.gray700};
  `,
};

const Layout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  height: 40px;
  flex-direction: row;
  ${theme.breakpoint('md')} {
    flex-direction: column;
  }
  ${theme.breakpoint('lg')} {
    flex-direction: row;
  }
`;

const LayoutFilters = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
`;

const FilterImage = styled(Icon)(
  () => css`
    width: 24px;
    height: 24px;
  `
);

const FilterText = styled.div`
  ${fontTypes.filters}
  margin-left: 8px;
`;
const FilterNumberMobile = styled.span`
  position: relative;
  background: ${theme.colors.gbrand500};
  border-radius: 50%;
  color: #fff;
  font-family: Roboto;
  font-size: 9px;
  font-weight: 500;
  line-height: 13px;
  z-index: 1;
  margin-top: -25px;
  margin-left: -10px;
  width: 14px;
  height: 14px;
  text-align: center;
  padding-top: 0.5px;
`;

const ContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${theme.breakpoint('md')} {
    justify-content: space-between;
    width: 100%;
    margin-top: 8px;
    align-items: center;
  }
  ${theme.breakpoint('lg')} {
    justify-content: flex-end;
    margin-top: 0px;
  }
`;

const ContainerCalendar = styled.div`
  padding: 0px;
  margin: 0px;
  width: 200px;
  ${theme.breakpoint('lg')} {
    width: auto;
    min-width: 200px;
  }
`;

export default function ({ filters, handleChangeFilters, cleanFilters, optionsSuggest }) {
  const { breakpoint } = useBreakpoints();
  const { t } = useTranslation();
  const [filtersMobile, setFiltersMobile] = useState({});
  const [typeFilterOptions, setTypeFilterOptions] = useState(null);
  const { config } = useConfig();
  const { merchant } = useAuth();
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const onSingleSelectListOpts = (type) => {
    setTypeFilterOptions(
      selectTypeLastMovements.map((i) => {
        if (i.id === type?.id) {
          i.selected = true;
        } else {
          i.selected = false;
        }
        return i;
      })
    );
  };

  useEffect(() => {
    onSingleSelectListOpts(filters?.type);

    setFiltersMobile(filters);
  }, [filters]);

  const handleChangeFiltersMobile = (filter) => {
    setFiltersMobile({ ...filtersMobile, ...filter });
  };

  const handleApplyFiltersMobile = () => {
    handleChangeFilters(filtersMobile);
    setShowMobileFilters(false);
  };

  const handleCleanFiltersMobile = () => {
    setFiltersMobile({});
    cleanFilters();
  };

  const handleCleanFiltersMobileClose = () => {
    setFiltersMobile({});
    setShowMobileFilters(false);
  };

  const showDetailFilter = isAllowed('LAST_MOVEMENTS_DETAIL_FILTER');

  //eslint-disable-next-line 
  const limitDays = useMemo(() => getLimitDays(merchant, config), [merchant]);

  return (
    <>
      {['xs'].includes(breakpoint) ? (
        <>
          <Layout>
            <InputSearch
              options={optionsSuggest}
              idMovement={(id) => handleChangeFilters({ id })}
              placeHolder={t('lastMovements.placeHolder')}
              noMatchText={t('lastMovements.noMatchText')}
              handleCleanFilterSearch={cleanFilters}
              fontColorTextMark={`${theme.colors.gbrand600}`}
              fontWeightTextMark="600"
              fontWeightTextNormal="normal"
            />
            <LayoutFilters onClick={() => setShowMobileFilters(true)}>
              <FilterImage icon="ic_filters_24" />
              {Object.keys(filters).length > 0 ? (
                <FilterNumberMobile>
                  {Object.keys(filters).length === 1
                    ? '1'
                    : Object.keys(filters).length === 2
                      ? '1'
                      : '2'}
                </FilterNumberMobile>
              ) : (
                ''
              )}
              <FilterText>{t('lastMovements.filters')}</FilterText>
            </LayoutFilters>
          </Layout>
        </>
      ) : (
        <Layout>
          <InputSearch
            options={optionsSuggest}
            idMovement={(id) => handleChangeFilters({ id })}
            placeHolder={t('lastMovements.placeHolder')}
            noMatchText={t('lastMovements.noMatchText')}
            handleCleanFilterSearch={cleanFilters}
            fontColorTextMark={`${theme.colors.gbrand600}`}
            fontWeightTextMark="600"
            fontWeightTextNormal="normal"
          />
          <ContainerFilters>
            {Object.keys(filters).length > 0 && <CleanFilter onClickCleanFilter={cleanFilters} />}
            <SelectType
              typeMovement={(type) => handleChangeFilters({ type })}
              isFiltered={Object.keys(filters).length > 0}
              placeHolder={t('lastMovements.placeHolderTipeMovement')}
              options={typeFilterOptions || selectTypeLastMovements}
              disabled={filters?.soft_descriptor?.id || filters?.id}
            />
            {showDetailFilter && (
              <SelectType
                typeMovement={(soft_descriptor) => handleChangeFilters({ soft_descriptor })}
                isFiltered={Object.keys(filters).length > 0}
                options={selectSoftDescriptorLastMovements}
                placeHolder="Detalle"
                transfer
                disabled={filters?.id}
              />
            )}
            <ContainerCalendar>
              <DatePicker
                onChange={({ init, finish }) =>
                  handleChangeFilters({ startDate: init, endDate: finish })
                }
                intervalDateSelect={{
                  init: filters.startDate || undefined,
                  finish: filters.endDate || undefined,
                }}
                placeholder="Seleccionar fecha"
                minDate={moment(merchant.created_at).toDate()}
                maxDate={moment().toDate()}
                limitDays={limitDays}
              />
            </ContainerCalendar>
          </ContainerFilters>
        </Layout>
      )}
      {showMobileFilters && (
        <Modal
          backgroundColor={`${theme.colors.gray200}`}
          animationDuration="0s"
          bgColorModal={`${theme.colors.gray200}`}
          borderColor="none"
          boxShadow="none"
          borderRadius="1px"
          minWidth="100vw"
          minHeight="100vh"
          animationDurationBg="0s"
          paddingLeft="0px"
          paddingRight="0px"
          paddingBotton="0px"
        >
          <FiltersMobile
            typeMovementMobile={(type) => handleChangeFiltersMobile({ type })}
            typeSoftDescriptorMobile={(soft_descriptor) => handleChangeFilters({ soft_descriptor })}
            optionsMovSoftType={selectSoftDescriptorLastMovements}
            optsMovType={selectTypeLastMovements}
            isFilteredMobile={Object.keys(filters).length > 0}
            onDateChangeMobile={(filters) => handleChangeFiltersMobile(filters)}
            handleResetMobile={() => handleCleanFiltersMobile()}
            onClickApplyMobile={
              Object.keys(filtersMobile).length > 0 ? () => handleApplyFiltersMobile() : ''
            }
            onClickBackMobile={() =>
              Object.keys(filtersMobile).length > 0 && Object.keys(filters).length === 0
                ? handleCleanFiltersMobileClose()
                : setShowMobileFilters(false)
            }
            onButtons={Object.keys(filtersMobile).length > 0 && true}
            filters={filtersMobile}
          />
        </Modal>
      )}
    </>
  );
}
